import { call, put, select, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { fromAuth } from '../selectors';

import { removeStoredAuthState, setStoredAuthState } from './utils';
import * as actions from './actions';
import { resourceCreateRequest } from '../resource/actions';

export function* loginRequest({ username, password }) {
  const loginObj = {
    login: username,
    password,
  };

  try {
    const promiseResponse = yield put(resourceCreateRequest('user/login', {}, loginObj));
    const response = yield promiseResponse;
    yield put(actions.authLoginSuccess({ username, ...response }));
  } catch (e) {
    yield put(actions.authLoginFailure(e));
  }
}

export function* watchLoginRequest(api, { payload }) {
  yield call(loginRequest, payload);
}

export function* watchLoginSuccess(api, { payload, meta }) {
  const token = yield select(fromAuth.getToken);
  if (token) {
    api.setToken(token);
  }

  yield call(setStoredAuthState, payload);

  const referrer = localStorage.getItem('redirectTo');
  if (referrer) {
    localStorage.removeItem('redirectTo');
    yield put(push(referrer));
  } else {
    yield put(push('/campaigns'));
  }
}

export function* watchLoginFailure(api) {
  yield call(removeStoredAuthState);

  yield put(push('/login'));
}

export function* watchLogout(api) {
  yield call(removeStoredAuthState);

  yield put(push('/login'));
}

export default function*({ api }) {
  const token = yield select(fromAuth.getToken);
  if (token) {
    api.setToken(token);
  }

  yield takeEvery(actions.AUTH_LOGIN_REQUEST, watchLoginRequest, api);
  yield takeEvery(actions.AUTH_LOGIN_SUCCESS, watchLoginSuccess, api);
  yield takeEvery(actions.AUTH_LOGIN_FAILURE, watchLoginFailure, api);
  yield takeEvery(actions.AUTH_LOGOUT, watchLogout, api);
}
